import React from 'react';
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Card,
  Col,
  Row,
} from 'reactstrap';
import logo200Image from '../assets/img/logo/20200723_UnitySuiteSqLogo512.webp';
import dlogo200Image from '../assets/img/logo/logo_2.png';
import Typography from '../components/Typography';
import queryString from 'query-string';
import axios from 'axios';

class SetPasswordPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      token: '',
    };
  }

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  login = () => {
    this.props.history.push('/login');
  };

  handleSubmit = event => {
    event.preventDefault();

    const data = {
      app_key: process.env.REACT_APP_KEY,
      email: this.state.email,
      password: this.state.password,
      token: this.state.token,
    };

    const self = this;
    const url = process.env.REACT_APP_API_URL;

    axios
      .post(url + ':3000/v1/user/set-password', data)
      .then(response => {
        const result = response.data;
        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        alert(
          'Your password has been changed successfully. Redirecting you to login page.',
        );
        self.props.history.push('/login');
      })
      .catch(error => {
        alert(error);
      });
  };

  componentDidMount() {
    const params = queryString.parse(this.props.location.search);

    this.setState({
      email: params.email,
      token: params.token,
    });
  }

  render() {
    return (
      <div className="ps-background">
        <Row className="AuthPage">
          <Col md={12} lg={4} className="d-none d-lg-block">
            <img
              src={logo200Image}
              style={{
                width: 150,
                cursor: 'pointer',
                display: 'block',
                margin: '0 auto',
              }}
              alt="logo"
            />
            <Typography className="mt-5 text-center h1 intro-title">
              UnitySuitePro
            </Typography>
            <p className="text-center version">
              {process.env.REACT_APP_VERSION}
            </p>
          </Col>
          <Col md={12} lg={8}>
            <div className="ps-auth-form">
              <Card body className="card-1">
                <Form onSubmit={this.handleSubmit} className="AuthForm">
                  <div className="text-left pb-4">
                    <img
                      src={dlogo200Image}
                      className="mb-3 d-block d-lg-none"
                      style={{ width: 40, height: 40, cursor: 'pointer' }}
                      alt="logo"
                    />
                    <Typography className="mb-5 h2">
                      Set Your Password
                    </Typography>
                  </div>
                  <FormGroup>
                    <Label for="password">Password</Label>
                    <Input
                      type="password"
                      placeholder="Your password"
                      name="password"
                      value={this.state.password}
                      onChange={this.changeHandler}
                      required
                    />
                  </FormGroup>
                  <hr />
                  <Button
                    size="lg"
                    className="theme-button-primary border-0"
                    block
                  >
                    Confirm
                  </Button>
                </Form>
              </Card>
              <h6 className="text-center form-bottom">
                <span className="mr-2">Already have account?</span>
                <a className="link-2" href="#login" onClick={this.login}>
                  Login
                </a>
              </h6>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}
export default SetPasswordPage;
